const ourWorkData = {
    en: {
        seo: {
            title: 'Photo Gallery | Dock & Boat Lift Projects | Tropical Marine Construction',
            description: 'View photos of completed dock construction, boat lift installation, and marine construction projects by Tropical Marine Construction in Cape Coral, FL.',
            keywords: 'Cape Coral dock photos, boat lift gallery, marine construction photos, SWFL dock builder gallery, Tropical Marine Construction projects'
        },
        ui: {
            galleryLabel: 'PHOTO GALLERY',
            galleryTitle: 'OUR WORK',
            gallerySubtitle: 'Cape Coral dock construction, boat lift installations, and waterfront projects.',
            noImagesText: 'Gallery coming soon.',
            specialsLabel: '',
            specialsTitle: '',
            specialsSubtitle: '',
            claimOfferBtn: '',
            claimOfferBtnLink: '',
        }
    },

    he: {
        seo: {
            title: 'Photo Gallery | Dock & Boat Lift Projects | Tropical Marine Construction',
            description: 'View photos of completed dock construction, boat lift installation, and marine construction projects by Tropical Marine Construction in Cape Coral, FL.',
            keywords: 'Cape Coral dock photos, boat lift gallery, marine construction photos, SWFL dock builder gallery'
        },
        ui: {
            galleryLabel: 'PHOTO GALLERY',
            galleryTitle: 'OUR WORK',
            gallerySubtitle: 'Cape Coral dock construction, boat lift installations, and waterfront projects.',
            noImagesText: 'Gallery coming soon.',
            specialsLabel: '',
            specialsTitle: '',
            specialsSubtitle: '',
            claimOfferBtn: '',
            claimOfferBtnLink: '',
        }
    }
};

export function getOurWorkData(language) {
    return ourWorkData[language === 'he' ? 'he' : 'en'];
}

export default ourWorkData;
